import request from '@/utils/request'

/**
 * 查询家政服务工单详情
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHousekeepingServPool(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServPool/queryHousekeepingServPool',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询家政服务工单处理记录
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryHouseServPoolUser(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServPoolUser/queryHouseServPoolUser',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询资源使用记录
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listResourceStoreUseRecords(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/resourceStore/listResourceStoreUseRecords',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}